import { Box, Flex, Skeleton, SkeletonCircle } from '@chakra-ui/react';

export const PDPSkeleton = () => (
    <Flex flexWrap="wrap" aria-label="Loading PDP page" aria-busy="true">
        <Flex w="50%" mt={4} px={10}>
            <Skeleton w="100%" h="6" aria-label="Loading PDP page breadcrumbs" />
        </Flex>
        <Flex gap={8} w="100%" mt={4} px={10} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
            <Flex w={{ base: '100%', md: '60%' }} gap={2}>
                <Skeleton
                    w={{ base: '100%', md: '50%' }}
                    h="30rem"
                    aria-label="product image loading"
                />
                <Skeleton
                    display={{ base: 'none', md: 'block' }}
                    w="50%"
                    h="30rem"
                    aria-label="product image loading"
                />
            </Flex>
            <Flex flex={1} gap={8} flexWrap="wrap" padding={4}>
                <Box w="100%">
                    <Skeleton w="100%" h={6} aria-label="Loading product name" />
                    <Skeleton w="100%" h={9} mt={1} aria-label="Loading product reviews" />
                    <Skeleton w="100%" h={6} aria-label="Loading product price" />
                    <Skeleton w="100%" h={9} mt={6} aria-label="Loading product quantity" />
                </Box>
                <Skeleton w="100%" h={9} aria-label="Loading product shipping options" />
                <Box w="100%">
                    <Flex gap={2} w="100%">
                        <Skeleton w="100%" h={86} />
                        <Skeleton w="100%" h={86} />
                        <Skeleton w="100%" h={86} />
                    </Flex>
                    <Skeleton mt={2} w="100%" h={12} aria-label="Shipping option zip code" />
                </Box>
                <Box w="100%">
                    <Skeleton w="100%" h={10} aria-label="Add to bag" />
                    <Flex mt={2} justifyContent="center" w="100%">
                        <Skeleton w="9rem" h={10} aria-label="Add to Registry" />
                    </Flex>
                </Box>
            </Flex>
        </Flex>
        <Flex w="100%" px={10} mb={8}>
            <Skeleton
                width={{ base: '100%', md: '57%' }}
                height="20rem"
                aria-label="Loading product description"
            />
        </Flex>
        <Flex px={10} w="100%" mt={8} flexWrap="wrap">
            <Skeleton h={9} w="10rem" aria-label="Loading similar items" />
            <Flex w="100%" gap={4} mt={4}>
                <Skeleton w="100%" h="34rem" />
                <Skeleton w="100%" h="34rem" />
                <Skeleton display={{ base: 'none', md: 'block' }} w="100%" h="34rem" />
                <Skeleton display={{ base: 'none', md: 'block' }} w="100%" h="34rem" />
            </Flex>
            <Flex w="100%" justifyContent="center" mt={8} gap={1}>
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
            </Flex>
        </Flex>
        <Flex px={10} w="100%" mt={8} flexWrap="wrap">
            <Skeleton h={9} w="10rem" aria-label="Loading you may also like items" />
            <Flex w="100%" gap={4} mt={4}>
                <Skeleton w="100%" h="34rem" />
                <Skeleton w="100%" h="34rem" />
                <Skeleton display={{ base: 'none', md: 'block' }} w="100%" h="34rem" />
                <Skeleton display={{ base: 'none', md: 'block' }} w="100%" h="34rem" />
            </Flex>
            <Flex w="100%" justifyContent="center" mt={8} gap={1}>
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
                <SkeletonCircle size="4" />
            </Flex>
        </Flex>

        <Flex width="100%" px={10} mt={9}>
            <Skeleton w="100%" h="14rem" aria-label="Loading product reviews" />
        </Flex>
        <Flex width="100%" px={16} mt={9}>
            <Skeleton w="100%" h="42rem" aria-label="Loading page footer" />
        </Flex>
    </Flex>
);
